<template>
  <div class="teacher_judge_page">
    <Table class="main_table" size="large" stripe border :columns="tableHeader" :data="dataList">
      <template slot-scope="{row}" slot="className">
        {{row.grade}}{{row.className}}
      </template>
      <template slot-scope="{row}" slot="type">
        <span v-if="row.status == 1">答题卡</span>
        <span v-if="row.status == 2">教辅</span>
        <span v-if="row.status == 3">答题本</span>
        <span v-if="row.status == 4">练习册</span>
        <span v-if="row.status == 5">标签</span>
      </template>
      <template slot-scope="{row}" slot="status">
        <span v-if="row.status == 0">未处理</span>
        <span v-if="row.status == 1">已处理</span>
      </template>
      <template slot-scope="{row}" slot="pageTrackData">
        <a :href="trackUrl + row.pageTrackData" :download="trackUrl + row.pageTrackData" target="_blank" class="jump_color">蓝牙数据</a>
      </template>
      <template slot-scope="{row}" slot="pageTrackImage">
        <viewer :iamges="[trackUrl + row.pageTrackImage]">
          <img class="track_img" :src="trackUrl + row.pageTrackImage" alt="笔迹图片">
        </viewer>
      </template>
      <template slot-scope="{row}" slot="pageBoxImage">
        <viewer :iamges="[trackUrl + row.pageBoxImage]">
          <img class="track_img" :src="trackUrl + row.pageBoxImage" alt="笔迹图片">
        </viewer>
      </template>
      <!--<template slot-scope="{row}" slot="action">-->
        <!--<a class="jump_color" @click="jumpDetails(row.studentAnswerId)">详情</a>-->
      <!--</template>-->
    </Table>
    <!--<paging :totalNum="totalNum" :pageSize="pageSize" @pageCallback="teacherJudgeList"></paging>-->
  </div>
</template>
<script>
  import paging from '../templates/Paging.vue';
  import {_teacherJudgeList,} from '../api/api';
  import {YearMonthDate,alertTips} from '../common/common';
  import globalData from '../common/Global';
  export default {
    components:{paging},
    data(){
      return {
        pageSize:10, // 每页条数
        currentNum: 0, // 当前页码
        totalNum: 0, // 数据总条数
        dataList:[],// 学生蓝牙数据列表
        id:0,// 蓝牙数据编号
        trackUrl:globalData.trackUrl,
        tableHeader:[
          {
            title:"试卷",
            key:"answerSheetName"
          },
          {
            title:"类型",
            key:"type",
            slot:"type"
          },
          {
            title:"科目",
            key:"subject"
          },
          {
            title:"班级",
            key:"className",
            slot:"className"
          },
          {
            title:"学生",
            key:"username"
          },
          {
            title:"蓝牙数据",
            key:"pageTrackData",
            slot:"pageTrackData"
          },
          {
            title:"笔迹",
            key:"pageTrackImage",
            slot:"pageTrackImage"
          },
          {
            title:"笔迹带框",
            key:"pageBoxImage",
            slot:"pageBoxImage"
          },
          {
            title:"状态",
            key:"status",
            slot:"status"
          }
//          {
//            title:"操作",
//            key:"action",
//            slot:"action"
//          },
        ]
      }
    },
    methods:{
      // 获取老师批改的列表
      teacherJudgeList(){
        const self = this;
        _teacherJudgeList(self.id).then(res=> {
          if(res.code === 0) {
            self.dataList = res.data;
          }else{
            alertTips("error",res.message);
          }
        })
          .catch(err => {
            alertTips("error","请求失败，请刷新");
          })
      },
      //      跳转到详情页
      jumpDetails(id){
        this.$router.push(`/studentbluetoothDetails?id=${id}`)
      }
    },
    created(){
      this.id = this.$route.query.id;
    },
    mounted(){
      this.teacherJudgeList();
    }
  };
</script>
<style scoped>
  .track_img{
    display: block;
    height:80px;
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/components/TeacherJudge.vue